import { settings } from "app";
import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import { EditButton, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";

const ShowClinic = () => {
  return (
    <Show
      title="Детайли на клиника"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canManageClinics}>
              <EditButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleShowLayout sx={{ ...settings.style.shadowBox, padding: "2rem" }}>
        <TextField
          source="nameBg"
          label="Име на български"
        />
        <TextField
          source="nameEn"
          label="Име на английски"
        />
        <ReferenceField
          source="departmentId"
          reference={administrationRequests.getDepartmentsSelect()}
          label="Катедра"
        >
          <TextField source="fullName" />
        </ReferenceField>
        <ReferenceField
          source="hospitalityId"
          reference={administrationRequests.getHospitalitiesSelect()}
          label="Болница"
        >
          <TextField source="nameBg" />
        </ReferenceField>
      </SimpleShowLayout>
    </Show>
  );
};
export default ShowClinic;
